// Shared vue-dompurify-html options for the concierge apps.
//
// `svg` named configuration (usage: v-dompurify-html:svg="...") is meant for
// dealership logos, which are remote SVG documents fetched server-side.
// It restricts the sink to the SVG profile (no HTML/MathML) while re-allowing
// <use> and SMIL animation tags that DOMPurify strips by default. DOMPurify
// 3.4 still strips attributeName="href" on those tags, so animated href XSS
// stays blocked; the hook below additionally pins <use> refs to local
// fragments so a logo cannot pull external resources.
export const domPurifyOptions = {
    default: {},
    namedConfigurations: {
        svg: {
            USE_PROFILES: { svg: true, svgFilters: true },
            ADD_TAGS: ['use', 'animate', 'set'],
            ADD_ATTR: ['xlink:href', 'xlink:title', 'xmlns:xlink', 'xml:space'],
        },
    },
    hooks: {
        uponSanitizeAttribute: (node, data) => {
            if (
                node.nodeName?.toLowerCase() === 'use' &&
                (data.attrName === 'href' || data.attrName === 'xlink:href') &&
                !data.attrValue?.startsWith('#')
            ) {
                data.keepAttr = false;
            }
        },
    },
};
